

import { useTranslate } from "@/helper/translate";
import { SpotInfoDisplaySchema } from "./SpotSchema";
import { useEffect, useState } from "react";
import { useApiFetch } from "@/helper/apiFetch";
import { blobToDataURL } from '@/helper/sort';
import { useInView } from "@/hooks/inView";
import { set } from "zod";
import { Loader2 } from "lucide-react";


export function SpotItem({item, isSelected, listMode, onClick, onCheckChange }: { item: SpotInfoDisplaySchema, isSelected:boolean,listMode:boolean,  onClick: (id: string) => void, onCheckChange: (id: string, checked: boolean) => void}) {
  const apiFetch = useApiFetch();

const { translate } = useTranslate();
  //const [url, setURL] = useState(undefined as string | undefined);


  
//  useEffect(() => {


//   if(item.mediaFile && item.mediaFile.snapshotPath)
//   {
//       apiFetch(`/App/ServeImage?path=${encodeURIComponent(item.mediaFile.snapshotPath)}`)
//       .then(res => {
//         if (!res.ok) throw new Error("Failed to fetch");
//         return res.blob();
//       })
//       .then(blob => {
//          blobToDataURL(blob).then(dataUrl => {setURL( dataUrl as string ); } );
//       })
//       .catch(err => {
//         console.error(err);

//       });
//     }
//   }, [item]);

  // Observe the outer container (card or table row)
  const { ref, inView } = useInView<HTMLDivElement>({
    root: null,            // viewport
    rootMargin: "200px 0px", // start loading a bit before it’s actually visible
    threshold: 0.1
    
  });

  const [url, setURL] = useState(item.url);  // Track `url` in state


  useEffect(() => {
  // keep state in sync when parent replaces item
  setURL(item.url);
}, [item.id, item.url]);

  useEffect(() => {
    // Only load if:
    // - item has a path
    // - it is in view
    // - we don't already have a URL
    if (!inView) return;
    if (!item.snapshotPath) return;
    if (item.url) 
      {
        setURL(item.url);
        return;
      }

    let cancelled = false;

    apiFetch(`/App/ServeImage?path=${encodeURIComponent(item.snapshotPath)}`)
      .then(res => {
        if (!res.ok) throw new Error("Failed to fetch");
        return res.blob();
      })
      .then(blob => {
        if (cancelled) return;
        return blobToDataURL(blob);
      })
      .then(dataUrl => {
        if (!cancelled && dataUrl) {
           item.url = dataUrl as string;
          setURL(dataUrl as string);
        }
      })
      .catch(err => {
        if (!cancelled) {
          console.error(err);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [inView, item.snapshotPath, apiFetch, url, item.url]);
        

  return listMode?(
    <div  key={item.id} className={item.isDeleted ?  " relative hidden" : "relative border rounded-md border-gray-100 dark:border-zinc-600 dark:bg-zinc-700 shadow-lg shadow-gray-300 dark:shadow-zinc-800 hover:border-sky-600 hover:shadow-sky-200 dark:hover:border-orange-300 dark:hover:shadow-orange-950"}>
      {!item.isAutoGenerated ? (
      <input type="checkbox" className="absolute top-[8px] right-0 scale-150 accent-sky-600 dark:accent-orange-400 z-10" id={`item-${item.id}`} 
      checked={isSelected}
      
      onChange={(e) => { onCheckChange(item.id , e.target.checked); e.stopPropagation();}}      />
      ):(
         <div className="absolute top-[8px] right-1 accent-sky-600 dark:accent-orange-400 z-10" >Automatic</div>
      )}
    <div className="w-[220px] pt-3 px-2 cursor-pointer " onClick={() => {!item.isAutoGenerated && onClick(item.id )}}>
      <div ref={ref} className="logo flex w-full min-h-[75px] justify-center items-center mb-4">
       
{item.url ? (
    <img src={url} className="w-full h-auto opacity-60 hover:opacity-100 " />
  ) : (
    <div className="w-full h-auto min-h-[115px] flex justify-center items-center bg-gray-200 dark:bg-zinc-600">
      <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
    </div> // Show loading spinner or fallback while image is loading
  )}
                       
       
      </div>
      <div className="info text-xs text-gray-60">
        <h3 className="description font-bold truncate">{item.name}</h3>
        <p className="name text-wrap truncate">{item.mimeType} {item.mimeType?.startsWith("video") ? `- ${Math.round(item.length??0 * 100)/100 }s`:""}&nbsp;</p>
        <p>{translate("ui.datechanged")}: {item.dateChanged ? new Intl.DateTimeFormat("de-DE", {day:"2-digit",month:"2-digit",year:"numeric",}).format(new Date(item.dateChanged)) : ""}</p>
        <div className="flex w-[100%] justify-between my-2 bg-gray-100 dark:bg-zinc-600 py-1 pr-1 rounded-sm items-center">
          <p className={`name text-wrap truncate inline-block relative pl-2 spotStatusText${item.statusId}`}>
            {translate("ui.status_" + item.statusId)}
          </p>
          <div 
            className={`circle w-[24px] h-[24px] bg-gray-600 rounded-full p-2 spotStatus${item.statusId}`}
            ></div>
        </div>

        {item.error ? (
          <p className="name text-wrap truncate text-red-600 font-bold">{item.error}</p>
        ):null}
      </div>

     
    </div>

    </div>
  ):(
    <tr key={item.id} className="border-t hover:bg-gray-100 cursor-pointer dark:bg-zinc-700 dark:hover:bg-zinc-600" onClick={() => {!item.isAutoGenerated && onClick(item.id )}}>
      <td className="px-4 py-2">
        {!item.isAutoGenerated && (
        <input
          type="checkbox"
          checked={isSelected}
          onChange={(e) => onCheckChange(item.id , e.target.checked)}
          onClick={(e) => e.stopPropagation()}
          className="accent-sky-600 dark:accent-orange-400 w-4 h-4"
        />)}
      </td>
      <td className="px-4 py-2">
        {item.error ? (
          <div>
          <div>{item.name}</div>
          <div className="name text-wrap truncate text-red-600 font-bold">{item.error}</div>
          </div>
        ):item.name}
        
        </td>
      <td className="px-4 py-2">{item.mimeType}</td>
      <td className="px-4 py-2">{item.length?Math.round(item.length * 100)/100 + "s":""} </td>
      <td className="px-4 py-2 text-center">
      <div 
      className={`w-[100%] dark:text-black rounded-sm inline-block relative listView spotStatus${item.statusId}`}>
        {translate("ui.status_" + item.statusId)}
      </div>
      </td>
      <td className="px-4 py-2">{item.dateChanged ? new Intl.DateTimeFormat("de-DE", {day:"2-digit",month:"2-digit",year:"numeric",}).format(new Date(item.dateChanged)) : ""}</td>
    </tr>
    
  )
}